import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGoogleBrandedStyle0 = cosmosIconCss;

const CosmosIconGoogleBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGoogleBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f67fe7194b571fb23384c0f8084b1755e7cd1d1f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fab9383b0ac697916a3af5d01cf42af6ae1935b4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '007d4b264994a04ecde9c23382d74ffa39f66128', d: "M19.822 11.205c0-.638-.058-1.252-.164-1.84h-8.477v3.485h4.844a4.15 4.15 0 0 1-1.808 2.708v2.267h2.92c1.703-1.571 2.685-3.878 2.685-6.62Z", fill: "#4285F4" }), h("path", { key: '8efa77d12c49a08e0b4dd3d2b38198697d98fe39', d: "M11.18 20.002c2.43 0 4.469-.802 5.958-2.177l-2.921-2.267c-.802.54-1.825.868-3.036.868-2.34 0-4.329-1.58-5.04-3.707H3.144v2.324c1.481 2.938 4.517 4.959 8.036 4.959Z", fill: "#34A853" }), h("path", { key: 'c4a536d8baedc9948ecb21290a8cf35b7ee284b6', d: "M6.14 12.71A5.393 5.393 0 0 1 5.854 11c0-.597.106-1.17.286-1.71V6.968H3.146A8.89 8.89 0 0 0 2.18 11a8.89 8.89 0 0 0 .966 4.034l2.332-1.817.662-.507Z", fill: "#FBBC05" }), h("path", { key: '5f81cfb3a656f1d7c797f42ee660a9bb6e9963de', d: "M11.18 5.584c1.326 0 2.504.458 3.445 1.342l2.578-2.578C15.64 2.892 13.61 2 11.18 2 7.662 2 4.627 4.021 3.146 6.967L6.14 9.29c.712-2.128 2.7-3.707 5.04-3.707Z", fill: "#EA4335" }))));
    }
    static get style() { return CosmosIconGoogleBrandedStyle0; }
}, [1, "cosmos-icon-google-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGoogleBranded$1);
            }
            break;
    } });
}

const CosmosIconGoogleBranded = CosmosIconGoogleBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGoogleBranded, defineCustomElement };
